module.exports = {
      id: "ic-active-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-active-usage",
      toString: function () {
        return this.url;
      }
    }